import type { FormControlProps as _FormControlProps } from "@chakra-ui/react";
import { forwardRef, FormControl as _FormControl } from "@chakra-ui/react";

export type FormControlProps = { isPrivate?: boolean; isSuccess?: boolean } & _FormControlProps;

export const FormControl = forwardRef<FormControlProps, "div">(
    ({ isPrivate = true, isSuccess = false, isRequired, ...props }, ref) => (
        <_FormControl
            data-privacy={`${isPrivate}`}
            data-success={`${isSuccess}`}
            isRequired={isRequired}
            ref={ref}
            {...props}
            mt={"4"}
        />
    )
);
